import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 py-20">
        <div className="label-sm mb-3">Legal</div>
        <h1 className="font-display text-4xl sm:text-5xl">Privacy Policy</h1>
        <p className="text-zinc-500 text-sm mt-2">Effective date: 25 Aug 2025 · Traders Spring Group</p>

        <div className="card-tech rounded-lg p-5 mt-8">
          <p className="text-sm text-zinc-400">
            We collect only what we need to run evaluations, fund traders in simulation, and process payouts. We don't sell personal data.
          </p>
        </div>

        <div className="mt-10 space-y-8 text-zinc-300 leading-relaxed text-sm">
          <Section n="1" t="Information We Collect">
            <ul className="list-disc pl-5 space-y-1 marker:text-[#00ff66]">
              <li><strong className="text-white">Account & Contact:</strong> name, email, country, and payment references.</li>
              <li><strong className="text-white">Trading Data:</strong> performance metrics from trading accounts used in our programs.</li>
              <li><strong className="text-white">KYC (for payouts):</strong> basic identity (name, country, wallet address); for larger payouts, we may request government ID and/or proof of address.</li>
              <li><strong className="text-white">Technical:</strong> device, IP, and cookie data for security and analytics.</li>
            </ul>
          </Section>
          <Section n="2" t="How We Use Data">
            <ul className="list-disc pl-5 space-y-1 marker:text-[#00ff66]">
              <li>To create and manage evaluation / funded simulations and dashboards.</li>
              <li>To process payments and cryptocurrency payouts (typically within 24–72 hours of approval).</li>
              <li>To comply with anti-fraud and anti-money-laundering (AML) obligations.</li>
              <li>To communicate updates, rules, and service changes.</li>
            </ul>
          </Section>
          <Section n="3" t="Legal Basis">
            We process data based on contract performance (providing our service), legitimate interests (fraud prevention, service improvement), and compliance duties (AML/KYC when required).
          </Section>
          <Section n="4" t="Sharing & Third Parties">
            <ul className="list-disc pl-5 space-y-1 marker:text-[#00ff66]">
              <li>We do <strong className="text-white">not</strong> sell personal data.</li>
              <li>We may share limited data with vendors strictly to operate our services (e.g., cloud hosting, analytics, email provider). These vendors are bound by confidentiality and data-processing terms.</li>
              <li>Trading occurs on Deriv MT5 demo infrastructure; we have <strong className="text-white">no official affiliation</strong> with Deriv.</li>
            </ul>
          </Section>
          <Section n="5" t="Data Retention">
            We retain account and trading records for as long as you maintain an account and as required for compliance. You can request deletion; some records may be retained where laws require.
          </Section>
          <Section n="6" t="Security">
            We use reasonable administrative, technical, and physical safeguards. No method of transmission or storage is 100% secure.
          </Section>
          <Section n="7" t="Cookies & Analytics">
            We may use cookies or similar technologies for basic analytics and session functionality. You can control cookies in your browser settings; some features may not work without them.
          </Section>
          <Section n="8" t="Your Rights">
            <ul className="list-disc pl-5 space-y-1 marker:text-[#00ff66]">
              <li>Access, update, or delete certain personal data.</li>
              <li>Opt out of non-essential communications.</li>
              <li>Contact us at <a href="mailto:support@tradersspringfunding.com" className="text-[#00ff66] hover:underline">support@tradersspringfunding.com</a>.</li>
            </ul>
          </Section>
          <Section n="9" t="Children">Our services are for users aged 18+ only. We do not knowingly collect data from minors.</Section>
          <Section n="10" t="International Transfers">Data may be processed in locations where we or our vendors operate. We take steps to protect data during such transfers.</Section>
          <Section n="11" t="Changes to This Policy">We may update this Privacy Policy. Material changes will be posted on this page with an updated effective date.</Section>
          <Section n="12" t="Governing Law">This Policy is governed by the laws of <strong className="text-white">St. Vincent & The Grenadines</strong>.</Section>
          <Section n="13" t="Contact">
            Email: <a href="mailto:support@tradersspringfunding.com" className="text-[#00ff66] hover:underline">support@tradersspringfunding.com</a>
          </Section>
        </div>
        <p className="mt-12 text-xs text-zinc-600">© Traders Spring Group. All rights reserved.</p>
      </main>
      <Footer />
    </div>
  );
}

function Section({ n, t, children }) {
  return (
    <div>
      <h2 className="font-display text-xl text-white">{n}. {t}</h2>
      <div className="mt-2 text-zinc-400">{children}</div>
    </div>
  );
}
